<template>
  <section class="container">
    <div class="list">
      <div class="item animate__animated animate__fadeInUp" v-for="item in cases.list" :key="item.id">
        <div class="img">
          <img :src="$baseURL + item.thumb" />
        </div>
        <h2>{{ item.title }}</h2>
        <p class="dh_text">{{ item.description }}</p>

        <div class="btn">
          <router-link class="iconfont icon-jiantou" :to="{ path: '/countact/lx' }">Obtain Solutions</router-link>
          <router-link class="iconfont icon-jiantou" :to="{ path: '/case/info', query: { id: item.id } }">Learn
            More</router-link>
        </div>
      </div>
      <Loading v-show="loading"></Loading>
    </div>

    <Pages v-if="cases.list.length" @numberChange="numberChange" :last="cases.page_count"></Pages>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      cid: this.$route.query.cid,
      page: 1,
      cases: {
        page_count: 1,
        list: [],
      },
    };
  },
  methods: {
    async casesIndex() {
      this.loading = true;
      let res = await service.casesIndex({ industry_id: this.cid, page: this.page });

      this.loading = false;
      if (res.code == 1) {
        this.cases = res.data.caselist;
        console.log(this.cases);
      }
    },
    numberChange(number) {
      this.page = number;
    },
  },
  created() {
    this.casesIndex();
  },
  watch: {
    $route(to, from) {
      this.cid = to.query.cid;
    },
    page() {
      this.casesIndex();
    },
    cid() {
      this.casesIndex();
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 25px;
  grid-row-gap: 30px;
  position: relative;

  .item {
    width: 100%;

    .img {
      width: 100%;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        border-radius: 15px;
        transition: all 0.3s;
      }
    }

    h2 {
      margin: 15px 0 3px;
      font-size: 20px;
    }

    p {
      width: 100%;
      color: #666;
    }

    .btn {
      display: flex;
      margin-top: 10px;

      a {
        color: var(--themeColor2);
        display: flex;
        flex-direction: row-reverse;
        margin-right: 20px;
        border-radius: 20px;
        border: 1px solid var(--themeColor2);
        padding: 8px 20px;
        font-size: 14px;
        font-family: Regular !important;
        transition: all 0.3s;
        white-space: nowrap;

        &::before {
          margin-left: 10px;
          font-family: iconfont !important;
        }

        &:hover {
          background: var(--themeColor2);
          color: #fff;
        }
      }
    }

    &:hover {
      .img {
        img {
          transform: scale(1.1);
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .list {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>